import {ColumnProps} from 'antd/lib/table';

export enum FilterType {
  FULLTEXT = 'fulltext',
  DATE_FROM = 'dateFrom',
  DATE_TO = 'dateTo',
  PAYMENT_TYPES = 'paymentTypes',
  ERROR_TYPES = 'errorTypes',
  PAY_STATUS_TYPES = 'payStatusTypes',
  CLUBIDS = 'clubIds',
}

export enum PaymnetTypes {
  DEBT = 'debt',
  OSP = 'osp',
  DSP = 'dsp',
}

export enum ErrorTypes {
  WITH = 'with',
  WITHOUT = 'without',
}

export enum PayStatusTypes {
  PAID = 'paid',
  UNPAID = 'unpaid',
}
export interface History {
  type: string;
  message: string;
  date: string;
  error?: any;
}

export interface Payment {
  id: string;
  type: string;
  reference: string;
  memberPK?: string;
  amount: number;
  currency: string;
  history: History[];
  processed: boolean;
  createdAt: string;
}

export interface PaymentHistoryProps {
  paymentData: Payment[];
  columns: Array<ColumnProps<Payment>>;
  totalPages: number;
  refetch: (variables: any) => void;
  regionId: string;
  loading: boolean;
  clubs: Club[];
}

export interface PaymentHistoryState {
  filter: PaymentHistoryFilter;
  activeKey: string;
  currentPage: number;
  isExportModalOpen: boolean;
  isDropdownOpen: boolean;
}

export interface PaymentHistoryFilter {
  fulltext: string;
  paymentTypes: PaymnetTypes[];
  errorTypes: ErrorTypes[];
  payStatusTypes: PayStatusTypes[];
  dateFrom: string;
  dateTo: string;
  clubIds: string[];
}

interface Club {
  id: string;
  name: string;
}


// WEBPACK FOOTER //
// ./src/pages/PaymentHistoryPage/interfaces/index.ts